<div class="contains-button">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-borders-config [device]="device" [class]="class" [borderClass]="class['note-product__boundary']"
      [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
    </app-borders-config>
    </div>
  </ng-container>

  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">

          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình tái sử dụng thiết kế-->

      <!-- Cấu hình đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['note-product']"
          [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['note-product__boundary']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['note-product']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- Cấu hình hiệu ứng -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-choose-animations-config [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id"
          [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['note-bill']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'"
          (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['note-product__boundary']"
        [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
      </app-borders-radius-config>
    </div>
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 2">
      <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device"
        [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>